import {createSelector} from 'reselect';

// Clients redux state
const clientsReducerSelector = state => state.clients;

// Clients List
const clientsSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('payload')
);

// Clients is fetching
const clientsIsFetchingSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('isFetching')
);

// Clients error
const clientsErrorSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('error')
);

// Clients created
const clientsCreatedSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('created')
);

// Clients updated
const clientsUpdatedSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('updated')
);

// Clients deleted
const clientsDeletedSelector = createSelector(
    clientsReducerSelector,
    clientsReducer => clientsReducer.get('deleted')
);

export {
    clientsSelector,
    clientsIsFetchingSelector,
    clientsErrorSelector,
    clientsCreatedSelector,
    clientsUpdatedSelector,
    clientsDeletedSelector
};